Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}


function throttle(func, delay) {
    // 节流函数，确保在短时间内只执行一次
    let lastCall = 0;
    return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) return;
        lastCall = now;
        return func(...args);
    };
}

export function enableAutoScroll(tableElement, onScrollEndCallback) {
    const contentWrapper = tableElement.bodyWrapper;

    if (!contentWrapper) {
        console.error('contentWrapper not found');
        return;
    }

    let animationId = null;
    let isScrolling = false;
    const scrollSpeed = 20; // 每秒滚动的像素数，适当降低以降低滚动速度


    // 鼠标离开事件的节流处理
    const throttledHandleMouseLeave = throttle(() => {
        if (!isScrolling) {
            isScrolling = true;
            animateScroll();
        }
    }, 200);

    // 鼠标进入事件的节流处理
    const throttledHandleMouseEnter = throttle(() => {
        isScrolling = false;
        cancelAnimationFrame(animationId);
    }, 200);

    // 添加事件监听器：鼠标进入和离开事件
    // contentWrapper.addEventListener('mouseenter', throttledHandleMouseEnter);
    // contentWrapper.addEventListener('mouseleave', throttledHandleMouseLeave);

    // 动画滚动函数
    function animateScroll() {
        // 如果内容区域高度不超过显示区域，不进行滚动
        if (contentWrapper.offsetHeight >= contentWrapper.scrollHeight) {
            isScrolling = false;
            // 如果内容高度不超过显示区域，无法滚动，延时10秒返回到底。
            setTimeout(onScrollEndCallback, 1000 * 10)
            return;
        }

        // 计算滚动的起始位置、结束位置和滚动的距离
        const start = contentWrapper.scrollTop;
        const end = contentWrapper.scrollHeight - contentWrapper.offsetHeight;
        const distance = end - start;

        // 计算滚动的持续时间
        const duration = distance / scrollSpeed * 1000;

        let startTime = null;

        // 滚动的每一步动画
        function scrollStep(timestamp) {
            if (!startTime) {
                startTime = timestamp;
            }

            // 计算已经经过的时间比例
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // 根据时间比例计算当前滚动位置
            contentWrapper.scrollTop = start + distance * progress;

            // 如果滚动未完成，则继续请求下一帧
            if (progress < 1) {
                animationId = requestAnimationFrame(scrollStep);
            } else {
                // 滚动完成时的回调函数
                onScrollEndCallback();
                contentWrapper.scrollTop = 0;
                isScrolling = false;
            }
        }

        // 请求执行动画帧
        animationId = requestAnimationFrame(scrollStep);
    }

    // 初始化滚动
    animateScroll();

    // 返回清理函数，用于移除事件监听器和取消动画帧
    return () => {
        cancelAnimationFrame(animationId);
        contentWrapper.removeEventListener('mouseenter', throttledHandleMouseEnter);
        contentWrapper.removeEventListener('mouseleave', throttledHandleMouseLeave);
    };
}


// 表格自动滚动
//需要传入DOM
export function tableAutoScroll(table, fun) {
    // 拿到表格挂载后的真实DOM
    // const table = this.$refs[ref];
    // 拿到表格中承载数据的div元素
    const divData = table.bodyWrapper
    divData.onmouseover = function () {
        cancelAnimationFrame(t);
    }; //鼠标移入，停止滚动
    divData.onmouseout = function () {
        start()
    }; //鼠标移出，继续滚动

    // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
    let t;
    let index = 0;

    divData.scrollTop = 0;

    function start() {
        // 数据少于表格高度停止滚动
        if (divData.clientHeight >= divData.scrollHeight) {
            return;
        }
        index += 1;
        if (index === 5) {
            // 元素自增距离顶部1像素
            divData.scrollTop += 1;
            index = 0;
        }
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop >= divData.scrollHeight) {
            fun();
            // console.log('到底了！')
            // 重置table距离顶部距离
            divData.scrollTop = 0
        }
        t = requestAnimationFrame(start)
    }

    start()
}


//合并单元格
export function handleTable({
                                row,
                                column,
                                mergeArrays = [],
                                currentIndex = "goods_index",
                                totalLength = "goods_total_length"
                            }) {
    try {
        let arr = [
            "操作",
            "备注",
            "订单编号",
            "合同类型",
            "客户名称",
            "订单号",
            "商城单号",
            "商城订单编号",
            "供应商订单编号",
            "供应商",
            "提交时间",
            "采购商",
            "订单金额",
            "责任销售",
            "日期",
            "订单类型",
            "订单状态",
            "逾期记录",
            "开票日期",
            "出货日期",
            "发票号码",
            "发货状态",
            "账期",
            "订单总价",
            "收款金额",
            "应收金额",
            "物流公司",
            "物流单号",
            "发货时间",
            "操作人",
            "条码",
            "仓库名称",
            "选择",
            ...mergeArrays
        ];
        if (row[totalLength] > 1) {
            if (arr.indexOf(column.label) !== -1 && row[currentIndex] === 0) {
                return {
                    rowspan: row[totalLength],
                    colspan: 1,
                };
            }
            if (arr.indexOf(column.label) !== -1 && row[currentIndex] !== 0) {
                return {
                    rowspan: 0,
                    colspan: 0,
                };
            }
        }
        return {
            rowspan: 1,
            colspan: 1,
        };
    } catch (e) {
        console.log(e)
    }

}


/**
 * 让浏览器全屏切换
 * @returns {boolean} 是否是全屏状态
 */
export function toggleFullscreen(el, fullscreen) {
    if (!el) {
        el = document.documentElement;
        if (fullscreen === undefined) {
            fullscreen = !(
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement
            );
        }
    }
    if (fullscreen) {
        const rfs = (
            el.requestFullScreen ||
            el.webkitRequestFullScreen ||
            el.mozRequestFullScreen ||
            el.msRequestFullScreen
        );
        if (rfs) {
            rfs.call(el);
        } else {
            throw new Error('您的浏览器不支持全屏模式');
        }
    } else {
        const cfs = (
            document.exitFullScreen ||
            document.webkitCancelFullScreen ||
            document.mozCancelFullScreen ||
            document.msExitFullscreen
        );
        if (cfs) {
            cfs.call(document);
        }
    }
    return fullscreen;
}

/**
 * 获取屏幕宽度
 * @returns {number}
 */
export function screenWidth() {
    return document.documentElement.clientWidth || document.body.clientWidth;
}

/**
 * 获取屏幕高度
 * @returns {number}
 */
export function screenHeight() {
    return document.documentElement.clientHeight || document.body.clientHeight;
}

/**
 * 深度克隆对象
 * @param obj
 * @returns {{}|*}
 */
export function deepClone(obj) {
    let result;
    const type = typeOf(obj);
    if (type === 'Object') result = {};
    else if (type === 'Array') result = [];
    else return obj;
    Object.keys(obj).forEach(key => {
        const copy = obj[key], cType = typeOf(copy);
        if (cType === 'Object' || cType === 'Array') result[key] = deepClone(copy);
        else result[key] = obj[key];
    });
    return result;
}

/**
 * 获取变量类型
 * @param obj
 * @returns {string}
 */
export function typeOf(obj) {
    if (obj === null) return 'Null';
    if (obj === undefined) return 'Undefined';
    return Object.prototype.toString.call(obj).slice(8, -1);
}

//数组去重
export function unique(arr) {
    if (!Array.isArray(arr)) {
        console.log('type error!')
        return
    }
    let array = [];
    let obj = {};
    for (let i = 0; i < arr.length; i++) {
        if (!is_Empty(arr[i])) {
            if (!obj[arr[i]]) {
                array.push(arr[i])
                obj[arr[i]] = 1
            } else {
                obj[arr[i]]++
            }
        }
    }
    return array;
}
// 将商品俗称中的英文去除
function strNames(text) {
    if (is_Empty(text)) return "";
    let str = text, val = "";
    for (let i = 0; i < str.length; i++) {
        const el = str[i];
        if (/[\u4e00-\u9fa5]/.test(el)) {
            val += el;
        }

    }
    return val;
}

//将订单列表中的多个商品拆分为多个订单。
export function orderGoodsSplice(array) {
    try {
        if (is_Empty(array)) return [];
        let arr = array.concat([]);
        let tempList = [];
        for (let i = 0; i < arr.length; i++) {
            let order = Object.assign({}, arr[i]);

            //如果当前订单列表上并没有返回订单商品信息，则直接向订单列表中push数据。
            if (is_Empty(order.orderGoodsBeans)) tempList.push(order);
            for (let j = 0; j < order.orderGoodsBeans.length; j++) {
                let e = order.orderGoodsBeans[j];
                // 因为商品名称需要展示为俗称+标准名称,所以将商品俗称中的英文去掉,以便于拼接
                e.goods_nonstandard_name = strNames(e.goods_nonstandard_name);
                // 有些遗留订单没有俗称,那就用商品名称替代
                if (is_Empty(e.goods_nonstandard_name)) {
                    e.goods_nonstandard_name = e.goods_name;
                }
                e.goods_name = `${e.goods_name} ${e.goods_standard_name}`
                let good = Object.assign({}, order);
                e.spec_name = specNameInit(e)
                good.orderGoodsBeans = [e];
                good.goods_total_length = order.orderGoodsBeans.length;
                good.goods_index = j;
                tempList.push(good);
            }
        }
        return tempList;
    } catch (e) {
        console.log(e);
        return [];
    }

}


//判断是否为空
export function is_Empty(targe) {
    if (targe === null) {
        return true;
    }
    if (targe === undefined) {
        return true;
    }
    if (typeof targe == 'number')
        return false;
    if (typeof targe == 'string') {
        if (targe == '') {
            return true;
        } else {
            return false;
        }
    }
    if (typeof targe == 'object') {
        for (let i in targe) {
            return false;
        }
        return true;
    }
    return false;

}

/* 计算两个时间相差几天 */
export function DateDiff(start, end) {
    let days = null;
    start = new Date(start);
    end = new Date(end);
    if (end > start) {
        days = parseInt(Math.abs(end - start) / 1000 / 60 / 60 / 24);
    } else {
        days = parseInt(Math.abs(start - end) / 1000 / 60 / 60 / 24); // 如果不限制对比时间和当前时间大小可以不用if
    }
    return days + 1;
}

export function randomColor() {
    let colors = `#ff684c,#26E88F,#26BEF1,#2D63FF,#266B9D,#ff9e46,#FF65E5,#2F0000,#12C8C1,#600030,#FABE38,#460046,#28004D,#EBD3E8,#272727,#4D0000,#820041,#5E005E,#3A006F,#3C3C3C,#600000,#9F0050,#750075,#4B0091,#4F4F4F,#750000,#BF0060,#930093,#5B00AE,#5B5B5B,#930000,#D9006C,#AE00AE,#6F00D2,#6C6C6C,#AE0000,#F00078,#D200D2,#8600FF,#7B7B7B,#CE0000,#FF0080,#E800E8,#921AFF,#8E8E8E,#EA0000,#FF359A,#FF00FF,#9F35FF,#9D9D9D,#FF0000,#FF60AF,#FF44FF,#B15BFF,#ADADAD,#FF2D2D,#FF79BC,#FF77FF,#BE77FF,#BEBEBE,#FF5151,#FF95CA,#FF8EFF,#CA8EFF,#d0d0d0,#ff7575,#ffaad5,#ffa6ff,#d3a4ff,#E0E0E0,#FF9797,#FFC1E0,#FFBFFF,#DCB5FF,#F0F0F0,#FFB5B5,#FFD9EC,#FFD0FF,#E6CAFF,#FFD2D2,#FFECF5,#FFE6FF,#F1E1FF,#FFECEC,#FAF4FF,#000079,#000079,#003E3E,#006030,#006000,#000093,#003D79,#005757,#01814A,#007500,#0000C6,#004B97,#007979,#019858,#009100,#0000C6,#005AB5,#009393,#01B468,#00A600,#0000E3,#0066CC,#00AEAE,#02C874,#00BB00,#2828FF,#0072E3,#00CACA,#02DF82,#00DB00,#4A4AFF,#0080FF,#00E3E3,#02F78E,#00EC00,#6A6AFF,#2894FF,#00FFFF,#1AFD9C,#28FF28,#7D7DFF,#46A3FF,#4DFFFF,#4EFEB3,#53FF53,#9393FF,#66B3FF,#80FFFF,#7AFEC6,#79FF79,#AAAAFF,#84C1FF,#A6FFFF,#96FED1,#93FF93,#B9B9FF,#97CBFF,#BBFFFF,#ADFEDC,#A6FFA6,#CECEFF,#ACD6FF,#CAFFFF,#C1FFE4,#BBFFBB,#DDDDFF,#C4E1FF,#D9FFFF,#ECECFF,#D2E9FF,#DFFFDF,#FBFBFF,#467500,#424200,#5B4B00,#844200,#642100,#548C00,#5B5B00,#796400,#9F5000,#842B00,#64A600,#737300,#977C00,#BB5E00,#A23400,#73BF00,#8C8C00,#AE8F00,#D26900,#BB3D00,#82D900,#A6A600,#C6A300,#EA7500,#D94600,#8CEA00,#C4C400,#D9B300,#FF8000,#F75000,#9AFF02,#E1E100,#EAC100,#FF9224,#FF5809,#A8FF24,#F9F900,#FFD306,#FFA042,#FF8040,#B7FF4A,#FFDC35,#FFAF60,#FF8F59,#C2FF68,#FFE153,#FFBB77,#FF9D6F,#CCFF80,#FFE66F,#FFC78E,#FFAD86,#D3FF93,#FFED97,#FFD1A4,#FFBD9D,#DEFFAC,#FFF0AC,#FFDCB9,#FFCBB3,#E8FFC4,#FFF4C1,#FFE4CA,#FFDAC8,#EFFFD7,#FFF8D7,#FFEEDD,#FFE6D9,#F5FFE8,#613030,#616130,#336666,#484891,#6C3365,#743A3A,#707038,#3D7878,#5151A2,#7E3D76,#804040,#808040,#408080,#5A5AAD,#8F4586,#984B4B,#949449,#4F9D9D,#7373B9,#9F4D95,#AD5A5A,#A5A552,#5CADAD,#8080C0,#AE57A4,#B87070,#AFAF61,#6FB7B7,#9999CC,#B766AD,#C48888,#B9B973,#81C0C0,#A6A6D2,#C07AB8,#CF9E9E,#C2C287,#95CACA,#B8B8DC,#CA8EC2,#D9B3B3,#CDCD9A,#A3D1D1,#C7C7E2,#D2A2CC,#E1C4C4,#D6D6AD,#B3D9D9,#D8D8EB,#DAB1D5,#EBD6D6,#DEDEBE,#C4E1E1,#E6E6F2,#E2C2DE,#F2E6E6,#E8E8D0,#D1E9E9`
    colors = colors.split(',');
    return colors[Math.floor(Math.random() * colors.length)]
}

//根据传入的数组及value返回数组中与value一致的对象
export function filterValue(list, value) {
    let o = {name: ""};
    try {
        if (is_Empty(list) || is_Empty(value)) return o;
        let obj = list.find(el => el.dict_data_value == value);
        return obj || {name: ""}
    } catch (e) {
        return o;
    }

}


export function specNameInit(goods, key) {
    try {
        if (is_Empty(goods)) return "";
        let obj_key = 'orderGoodsSpecificationInputBeans';
        if (!is_Empty(key)) {
            obj_key = key;
        }
        let spc_name = [];
        let excludeFields = ['定制', '小于', '大于']
        if (!is_Empty(goods.specification_name) && excludeFields.every(el => goods.specification_name.indexOf(el) === -1)) {
            spc_name.push(goods.specification_name)
        }
        let obj = {};
        goods[obj_key].forEach(el => {
            obj[el.input_name] = Number(el.input_value);
        })

        //如果spc_name数组不为空说明该商品为标准商品则直接拼接就行，不需要加*号。
        if (!spc_name.length) {
            if (obj.hasOwnProperty('goods_length')) {
                spc_name.push(`${obj.goods_length}m`)
            }
            if (obj.hasOwnProperty('goods_width')) {
                spc_name.push(`${obj.goods_width}m`)
            }
            if (obj.hasOwnProperty('weight')) {
                spc_name.push(`${obj.weight}${goods.price_unit}`)
            }
            return spc_name.join("*");
        } else {
            if (obj.hasOwnProperty('goods_length')) {
                spc_name.push(`长度:${obj.goods_length}m`)
            }
            if (obj.hasOwnProperty('goods_width')) {
                spc_name.push(`宽度:${obj.goods_width}m`)
            }
            if (obj.hasOwnProperty('weight')) {
                spc_name.push(`重量:${obj.weight}${goods.price_unit}`)
            }
            return spc_name.join(" ");
        }
    } catch (e) {
        return ""
    }
}
export function updateUrl(url, key) {
    key = (key || 't') + '=';  //默认key是"t",可以传入key自定义
    let reg = new RegExp(key + '\\d+');  //正则：t=1472286066028
    let timestamp = +new Date();
    if (url.indexOf(key) > -1) { //有时间戳，直接更新
        return url.replace(reg, key + timestamp);
    } else {  //没有时间戳，加上时间戳
        if (url.indexOf('?') > -1) {
            var urlArr = url.split('?');
            if (urlArr[1]) {
                return urlArr[0] + '?' + key + timestamp + '&' + urlArr[1];
            } else {
                return urlArr[0] + '?' + key + timestamp;
            }
        } else {
            if (url.indexOf('#') > -1) {
                return url.split('#')[0] + '?' + key + timestamp + location.hash;
            } else {
                return url + '?' + key + timestamp;
            }
        }
    }
}


export function formatCurrency(amount, currencySymbol = '￥') {
    if (isNaN(amount)) {
        return 'Invalid amount';
    }

    if (Number(amount) === 0) return currencySymbol + amount;
    let amountStr = toDecimal2(amount);
    amountStr = amountStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return currencySymbol + amountStr;
}


export function getValueByStringKey(obj, key) {
    const keys = key.split('.');
    let result = obj;

    for (const k of keys) {
        // 如果属性名包含 [ ]，解析数组索引
        if (/\[\d+\]/.test(k)) {
            const [propName, index] = k.split('[');
            const idx = parseInt(index.slice(0, -1)); // 去掉末尾的 ']'
            if (result[propName] && Array.isArray(result[propName])) {
                result = result[propName][idx];
            } else {
                return undefined; // 或者抛出错误，根据需要处理
            }
        } else {
            // 否则，直接访问属性
            if (result[k]) {
                result = result[k];
            } else {
                return undefined; // 或者抛出错误，根据需要处理
            }
        }
    }

    return result;
}

export function toDecimal2(x, length) {
    length = length || 2;
    let sum = "1";
    while (sum.length <= length) {
        sum += "0";
    }
    sum = Number(sum);
    let f = parseFloat(x);
    if (isNaN(f)) {
        return 0;
    }
    f = Math.round(x * sum) / sum;
    let s = f.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + length) {
        s += '0';
    }
    return s;
}

export function decodeAndSanitizeId(encodedId) {
    // 解码 Base64 字符串
    let decodedId = encodedId

    // 清理 ID，确保它是一个有效的 CSS 选择器
    // 1. 移除任何非法字符（例如空格、斜杠等）
    // 2. 确保 ID 以字母或下划线开头
    // 3. 确保 ID 不以数字开头
    // 4. 替换非法字符为合法字符（例如使用下划线 `_`）
    decodedId = decodedId.replace(/[^a-zA-Z0-9_\-]/g, '_');
    decodedId = decodedId.replace(/^([^a-zA-Z_])/, '_$_1'); // 确保以字母或下划线开头
    decodedId = decodedId.replace(/^[^a-zA-Z_]/, '_');

    return decodedId;
}

// 减
export function sub(a, b) {
    a = Number(a);
    b = Number(b);
    let c, d, e;
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (mul(a, e) - mul(b, e)) / e;
}

// 乘
export function mul(a, b) {
    a = Number(a);
    b = Number(b);
    let c = 0, d, e;
    // if (typeof (a) == "number") {
    try {

        d = a.toString();
    } catch (error) {

    }
    try {
        e = b.toString();
    } catch (error) {

    }
    try {
        c += d.split(".")[1].length;
    } catch (f) {
    }
    try {
        c += e.split(".")[1].length;
    } catch (f) {
    }
    try {
        return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
    } catch (error) {
    }
}

/**
 * 生成随机ID
 * @param {number} length - 随机ID的长度
 * @returns {string} 随机生成的ID
 */
export function generateId(length = 8) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}